export default __webpack_public_path__ + "assets/job.eeefe553.svg";